function n(t, e) {
  return `nav-item-${t}-${e}`;
}
export {
  n as getNavId
};
